/** Short display labels for configuration keys (full descriptions stay in hints). */

const CONFIG_LABEL_SHORT: Record<string, string> = {
  telegram_api_id: 'Telegram API ID',
  telegram_api_hash: 'Telegram API hash',
  telegram_bot_token: 'Telegram bot token',
  email_delivery_mode: 'Delivery mode',
  email_from_name: 'Sender name',
  email_from_address: 'Sender email address',
  collector_scrape_workers: 'Scrape workers',
  collector_send_workers: 'Send workers',
  collector_embed_workers: 'Embedded workers',
  worker_max_jobs_per_worker: 'Max jobs / worker',
  worker_max_retries: 'Max retries',
  worker_lease_timeout_minutes: 'Job lease timeout',
  worker_heartbeat_timeout_seconds: 'Heartbeat stale',
  worker_idle_timeout_seconds: 'Idle shutdown',
  worker_shutdown_timeout_seconds: 'Shutdown grace',
  worker_parallel_http_requests: 'HTTP concurrency',
  worker_parallel_telegram_sends: 'Telegram concurrency',
  worker_poll_interval_seconds: 'Queue polling',
};

function humanizeKey(key: string): string {
  return key.replace(/_/g, ' ');
}

export function formatConfigLabel(
  key: string,
  opts?: { restartRequired?: boolean; modified?: boolean },
): string {
  const base = CONFIG_LABEL_SHORT[key] ?? humanizeKey(key);
  const suffix = [
    opts?.restartRequired ? '(restart)' : '',
    opts?.modified ? '*' : '',
  ]
    .filter(Boolean)
    .join(' ');
  return suffix ? `${base} ${suffix}` : base;
}

export function configGridClass(category: string): string {
  if (category === 'workers') {
    return 'settings-grid--config settings-grid--workers';
  }
  return 'settings-grid--config';
}
